import {
    GET_PAGE,
    SET_CLOSE_LIST_PAGE,
    SET_CLOSE_POPUP_ADD_PAGE,
    SET_CLOSE_POPUP_UPDATE_PAGE,
    SET_OPEN_LIST_PAGE,
    SET_OPEN_POPUP_ADD_PAGE,
    SET_OPEN_POPUP_UPDATE_PAGE,
    GET_ALL_PAGE,
    UPDATE_PAGE,
    DELETE_PAGE
} from '../../@jumbo/constants/ActionTypes';

const INIT_STATE = {
    dataPages: [],
    isOpenListPage: false,
    isOpenPopupAddPage: false,
    isOpenPopupUpdatePage: false,
    pages: []
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_PAGE: {
            return {
                ...state,
                dataPages: action.payload,
            };
        }
        case UPDATE_PAGE: {
            return {
                ...state,
                dataPages: state.dataPages.map(page => {
                    if (page._id == action.payload._id) {
                        page = action.payload;
                    }
                    return page;
                }),
                pages: state.pages.map(page => {
                    if (page._id == action.payload._id) {
                        page = action.payload;
                    }
                    return page;
                })
            }
        }

        case DELETE_PAGE: {
            return {
                ...state,
                dataPages: state.dataPages.filter(page => !action.payload.ids.includes(page._id)),
                pages: state.pages.filter(page => !action.payload.ids.includes(page._id))
            }
        }
        case GET_ALL_PAGE: {
            return {
                ...state,
                pages: action.payload
            }
        }
        case SET_OPEN_LIST_PAGE: {
            return {
                ...state,
                isOpenListPage: true,
            };
        }
        case SET_CLOSE_LIST_PAGE: {
            return {
                ...state,
                isOpenListPage: false,
            };
        }
        case SET_CLOSE_POPUP_ADD_PAGE: {
            return {
                ...state,
                isOpenPopupAddPage: false,
            };
        }
        case SET_OPEN_POPUP_ADD_PAGE: {
            return {
                ...state,
                isOpenPopupAddPage: true,
            };
        }
        case SET_CLOSE_POPUP_UPDATE_PAGE: {
            return {
                ...state,
                isOpenPopupUpdatePage: false,
            };
        }
        case SET_OPEN_POPUP_UPDATE_PAGE: {
            return {
                ...state,
                isOpenPopupUpdatePage: true,
            };
        }
        default:
            return state;
    }
};
